export default "__VITE_ASSET__54357eeb__"